import { useEffect, useState } from 'react';
import {
    useMap
} from '@vis.gl/react-google-maps';
import MapService, { IMapService } from '../services/MapService';
import MapPropertiesService from '../services/MapPropertiesService';
import { MapPolygon } from './MapPolygon';
import { isNullOrEmpty } from '../../../helpers/ObjectHelpers';
import MapApiRepository from '../repositories/MapApiRepository';

interface MapPecExamProps {
    pecExam: any
}

export const MapPecExam = ({
    pecExam
}: MapPecExamProps) => {

    const map = useMap();   
    const [isInitialized, setIsInitialized] = useState(false);
    const [features, setFeatures] = useState<any[]>([]);

    const mapService: IMapService = new MapService();
    const mapProperties = MapPropertiesService.properties;
    
    useEffect(() => {

        if (!map) return;

        if (isInitialized) return;

        const initialize = async () => {
            const response: any = await MapApiRepository.getPecFairwayAreasAsync(pecExam.pecId, pecExam.pilotagePecExamId);
            if (response.ok) {
                const bounds = new window.google.maps.LatLngBounds();
                const data = await response.json();
                const filteredData = data.filter((x: any) => !isNullOrEmpty(x.wkt));
                
                for (const fairwayArea of filteredData) {
                    if (isNullOrEmpty(fairwayArea.wkt)) continue;
                    mapService.setFairwayAreaGeometryAndBounds(fairwayArea);

                    fairwayArea.properties = {
                        name: fairwayArea.applied ? 'Innvilges etter pr&oslash;ve' : 'Allerede innvilgede omr&aring;der',
                        featureType: mapProperties.FairwayAreaFeatureType
                    };

                    if (!fairwayArea.applied) continue;
                    const coordinates = mapService.getCoordinatesFromGeometry(fairwayArea.geometry);
                    mapService.extendBounds(bounds, coordinates);
                }

                setFeatures(filteredData);

                map!.setCenter(bounds.getCenter());
                map!.fitBounds(bounds);
            }
        }

        initialize();
        setIsInitialized(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map, pecExam])

    return (
        features.map((feature: any, index: number) =>
            <MapPolygon
                ref={null}
                key={index}
                source={feature}
                
            />
        )
    )
}
